import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
const TableComponentRedux = React.lazy(() => import('./TableComponentRedux'));
const TableRedux = (props) => {
    return (_jsx(Suspense, { fallback: "loading...", children: _jsx(TableComponentRedux, Object.assign({}, props)) }));
};
export { TableRedux };
